import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const LogoutConfirmationModal = ({ isOpen, isClosed, onClose, onConfirm }) => {
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={isClosed}
        aria-labelledby="logout-dialog-title"
        aria-describedby="logout-dialog-description"
        PaperProps={{
          sx: {
            borderRadius: 4,
            p: 1,
            width: "100%",
            maxWidth: 420,
            boxShadow: 8,
          },
        }}
      >
        <DialogTitle
          id="logout-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            fontWeight: "bold",
            fontSize: "1.3rem",
            px: 4,
            pt: 3,
            pb: 1,
          }}
        >
          <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 32 }} />
          <span>Konfirmo Daljen</span>
        </DialogTitle>
        <DialogContent sx={{ px: 4, pb: 0 }}>
          <DialogContentText
            id="logout-dialog-description"
            sx={{ color: "text.secondary", fontSize: "1.05rem" }}
          >
            A je i sigurt që dëshiron të dalësh nga llogaria?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 4, pb: 3, pt: 2, justifyContent: "flex-end" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="inherit"
            sx={{ minWidth: 100 }}
            aria-label="Cancel logout"
          >
            Anulo
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="error"
            sx={{ minWidth: 100, boxShadow: 2, fontWeight: 600 }}
            aria-label="Confirm logout"
          >
            Dil nga Llogaria
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default LogoutConfirmationModal;
